import { motion } from "framer-motion";
import ProductCard from "@/components/product/ProductCard";
import { useRecentlyViewed } from "@/hooks/useRecentlyViewed";
import { useProducts } from "@/hooks/useProducts";
import { useLanguage } from "@/context/LanguageContext";

interface RecentlyViewedProps {
  excludeId?: string;
}

const RecentlyViewed = ({ excludeId }: RecentlyViewedProps) => {
  const { recentIds } = useRecentlyViewed();
  const { data: allProducts = [] } = useProducts();
  const { language } = useLanguage();

  const recentProducts = recentIds
    .filter((id) => id !== excludeId)
    .map((id) => allProducts.find((p) => p.id === id))
    .filter(Boolean)
    .slice(0, 4);

  if (recentProducts.length === 0) return null;

  return (
    <section className="container-luxury mt-20">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="text-center mb-12"
      >
        <span className="text-primary text-sm tracking-[0.3em] uppercase">
          {language === "ar" ? "شوهد مؤخراً" : "Recently Viewed"}
        </span>
        <h2 className="text-3xl md:text-4xl font-serif mt-4">
          {language === "ar" ? "منتجات شاهدتها" : "Your Recent Picks"}
        </h2>
      </motion.div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {recentProducts.map((product, index) => (
          <ProductCard key={product!.id} product={product!} index={index} />
        ))}
      </div>
    </section>
  );
};

export default RecentlyViewed;
